import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode, inject } from '@angular/core';
import { provideRouter, PreloadAllModules, withPreloading } from '@angular/router';

import { SOCKET_CONFIG_TOKEN, Socket, SocketIoConfig, provideSocketIo } from 'ngx-socket-io';


import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideNgxStripe } from 'ngx-stripe';
import { provideServiceWorker } from '@angular/service-worker';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsLoggerPlugin } from '@ngxs/logger-plugin';
import { LOCAL_STORAGE_ENGINE, SESSION_STORAGE_ENGINE, withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { provideStore } from '@ngxs/store';
import { AuthState } from './shared/state/auth.state';
import { provideGoogleAnalytics } from '@hakimio/ngx-google-analytics';
import { CartState } from './shared/state/cart.state';
import { ProductsState } from './shared/state/products.state';
import { environment } from '../environments/environment.development';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';
import { withNgxsWebSocketPlugin } from '@ngxs/websocket-plugin';
import { provideAnimations } from '@angular/platform-browser/animations';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'https://d2r31p9h1pd7zy.cloudfront.net/assets/i18n/', '.json');
}

const config: SocketIoConfig = {
  url: environment.api,
  options: {
    // transports: ['websocket'],
    autoConnect: false,
  }
};


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideClientHydration(),
    provideHttpClient(),
    provideGoogleAnalytics('G-XXS6P4T348'),
    importProvidersFrom(
      NgMultiSelectDropDownModule.forRoot()
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideNgxStripe('pk_live_51IOzTyBD7CtJ7vog77r46zh2eDmiHR444KYqPpSJpLL1tX938ZIiDO84xAZYYnfFGiQWyYBxt8tB3cI3EqNjNTQ800ttSk5ouh'),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    // provideServiceWorker('ngsw-worker.js', {
    //   enabled: !isDevMode(),
    //   registrationStrategy: 'registerWhenStable:30000',
    // }),
    provideStore(
      [AuthState, CartState, ProductsState],
      withNgxsReduxDevtoolsPlugin(),
      withNgxsLoggerPlugin({
        disabled: environment.production,
      }),
      withNgxsStoragePlugin({
        keys: [
          {
            key: AuthState,
            engine: LOCAL_STORAGE_ENGINE,
          },
          {
            key: CartState,
            engine: LOCAL_STORAGE_ENGINE,
          },
          {
            key: ProductsState,
            engine: SESSION_STORAGE_ENGINE,
          },
        ],
      }),
      // withNgxsRouterPlugin(),
      // withNgxsWebSocketPlugin()
    ),
    provideAnimations()
    // provideSocketIo(config),

  ],
};
// function provideGoogleAnalytics(arg0: string): import("@angular/core").EnvironmentProviders {
//   throw new Error('Function not implemented.');
// }
//
